export class PropertySubTypeDTO{
    
    public id!:number;
    public name!:string;
    
    constructor(){

    }
}